import { IconHeart, IconHeadphones, IconMoon, IconWind, IconPlant2 } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { PurchaseButton } from "@/components/common/PurchaseButton";

const ExtraFeatures = ({ onPurchase }: { onPurchase?: () => void }) => {
  const { t } = useTranslation();

  const features = [
    {
      icon: IconPlant2,
      titleKey: "extraFeatures.list.meditation.title",
      descriptionKey: "extraFeatures.list.meditation.description"
    },
    {
      icon: IconWind,
      titleKey: "extraFeatures.list.breath.title",
      descriptionKey: "extraFeatures.list.breath.description"
    },
    {
      icon: IconHeart,
      titleKey: "extraFeatures.list.affirmations.title",
      descriptionKey: "extraFeatures.list.affirmations.description"
    },
    {
      icon: IconMoon,
      titleKey: "extraFeatures.list.sleep.title",
      descriptionKey: "extraFeatures.list.sleep.description"
    },
    // {
    //   icon: Activity,
    //   titleKey: "extraFeatures.list.yoga.title",
    //   descriptionKey: "extraFeatures.list.yoga.description"
    // }
  ];

  return (
    <section className="py-6 md:py-8 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-4 lg:mb-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-4 md:mb-6">
            {t('extraFeatures.title')}
          </h2>
          {/* <p className="text-base mx-8 md:mx-auto md:text-xl text-slate-600 max-w-xl">
            {t('extraFeatures.subtitle')}
          </p> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 pb-8 md:p-8 rounded-2xl bg-white border border-slate-200 hover:md:border-sky-200 hover:md:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="mb-4">
                <div className={cn(
                  "w-10 h-10 md:w-14 md:h-14 rounded-full flex items-center justify-center",
                  index % 2 === 0
                    ? "bg-sky-500"
                    : "bg-teal-400"
                )}>
                  <feature.icon className="w-6 md:w-7 h-6 md:h-7 text-white" />
                </div>
              </div>
              <h3 className={cn(
                "text-lg md:text-xl font-semibold mb-3 group-hover:text-sky-500 transition-colors duration-300",
                index % 2 === 0
                  ? "text-sky-500 md:text-slate-900"
                  : "text-teal-500 md:text-slate-900"
              )}>
                {t(feature.titleKey)}
              </h3>
              <p className="text-base md:text-base text-slate-600 leading-relaxed">
                {t(feature.descriptionKey)}
              </p>
            </div>
          ))}
        </div>
      </div>

      {onPurchase && <PurchaseButton onPurchase={onPurchase} />}
    </section >
  );
};

export default ExtraFeatures;
